module.exports = __webpack_public_path__ + "static/media/wellbeing-foundations@2x.d3b1a902.png";